module.exports = __webpack_public_path__ + "img/ring_r_0_0_0.af05af00.png";